import VisitorCard from './VisitorCard';

export default VisitorCard;
